import React, { Component } from 'react';
import {Button, Card} from "antd";
import {Link} from "react-router-dom";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

export class CardExtraFunctionalities extends Component {

  render() {
    const { title, price, hired, intl, showInfoModal, id, addToCart, removeToCart, enable, newColor } = this.props;

    return (
      <Card
        style={{
          borderRadius: 10,
          boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)',
          border: 'none',
          margin: '10px 5px',
        }}
      >
        <div style={{ fontSize: 20, lineHeight: 1.2, marginBottom: 20 }}>¡Maneja el acceso a <b>tu contenido!</b></div>
        <Link to={'/'} style= {{fontWeight: "700", color: newColor}}>{title}</Link>
        <br/><br/>
        <div style={{ fontSize: 10, color: '#7E7E7E', }}>{intl.formatMessage({ id: 'extra_payment.for_only' })}</div>
        <div style={{ fontSize: 25, color: '#6F6F6F', fontWeight: 700, }} >{price} USD</div>
        <div style={{ textAlign: 'right', marginTop: 25, }}>
          {hired ? <Button type={'primary'} size={'large'} ghost style = {{fontWeight: "700"}} onClick={ () => removeToCart(id) }>
            {/* {intl.formatMessage({ id: 'extra_payment.hired' })} */}
            Eliminar
          </Button> : (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                type={'primary'}
                size={'large'}
                ghost
                onClick={ () => showInfoModal() }
                style = {{fontWeight: "700",padding: '0 9px'}}
              >
                {intl.formatMessage({ id: 'extra_payment.more_info' })}
              </Button>
              {enable &&
              <Button
                type={'primary'}
                size={'large'}
                onClick={ () => addToCart(id) }
                style={{fontWeight: "700", padding: '0 9px'}}
              >
                {intl.formatMessage({ id: 'extra_payment.hire' })}
              </Button>
              }              
            </div>
          )}
        </div>
      </Card>
    )
  }
}
const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CardExtraFunctionalities)))
